/**
 * LegalBanner.js — Floating bottom legal compliance banner with dismiss
 */
import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'lc_legal_banner_dismissed';

export default function LegalBanner() {
  const [visible,  setVisible]  = useState(false);
  const [exiting,  setExiting]  = useState(false);

  useEffect(() => {
    // Show after 2s if not already dismissed this session
    const dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      const t = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    setExiting(true);
    setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem(STORAGE_KEY, '1');
    }, 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-4 left-1/2 z-[9990] w-[calc(100vw-2rem)] max-w-2xl
        transition-all duration-400 ease-out
        ${exiting
          ? 'opacity-0 translate-y-6 scale-95'
          : 'opacity-100 translate-y-0 scale-100'
        }`}
      style={{ transform: `translateX(-50%) ${exiting ? 'translateY(24px) scale(0.95)' : 'translateY(0)'}` }}
    >
      <div
        className="relative rounded-2xl border border-yellow-400/30 shadow-2xl shadow-black/30 overflow-hidden"
        style={{
          background: 'rgba(20, 5, 5, 0.88)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
        }}
      >
        {/* Gold top accent line */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-yellow-400 to-transparent" />

        <div className="flex items-start gap-4 p-4 pr-12">
          {/* Icon */}
          <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-yellow-400/15 border border-yellow-400/25
            flex items-center justify-center text-lg mt-0.5">
            ⚖️
          </div>

          {/* Text */}
          <div className="flex-1 min-w-0">
            <p className="text-yellow-300 font-black text-xs uppercase tracking-widest mb-1.5">
              Important Notice
            </p>
            <p className="text-white/80 text-xs leading-relaxed">
              We follow all <span className="text-yellow-300 font-bold">Supreme Court regulations</span>,
              and hence online sale of firecrackers is restricted. Once you place an enquiry, our team
              will personally connect with you within{' '}
              <span className="text-yellow-300 font-bold">24 hours via WhatsApp or phone</span> to
              complete your order safely.
            </p>
          </div>
        </div>

        {/* Dismiss button */}
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center
            text-white/40 hover:text-white hover:bg-white/10 transition-all duration-200 text-lg"
        >
          ×
        </button>
      </div>
    </div>
  );
}
